/* =============================================================
   ILS — Collection page card behaviors.
   - Render gold SVG stars from data-rate.
   - Autoplay product card photos on the home / related rails every 2.0s
     (TASK-3129: the catalog/collection/search grid does NOT auto-advance).
   - Wire up the Sort button: shows current sort label; on change
     submits Dawn's facet form so the grid re-renders.
   Re-runs after facets re-render the grid container.
   ============================================================= */
(function () {
  var STAR_PATH = 'M12 2.6c.55 0 1.04.33 1.27.83l2.3 4.96 5.43.7c.55.07.99.45 1.16.97.16.51-.01 1.07-.42 1.43l-4.02 3.52 1.06 5.4c.1.54-.12 1.08-.57 1.4-.45.31-1.04.34-1.52.07L12 18.86l-4.69 2.61c-.48.27-1.07.24-1.52-.07-.45-.32-.67-.86-.57-1.4l1.06-5.4-4.02-3.52c-.41-.36-.58-.92-.42-1.43.17-.52.61-.9 1.16-.97l5.43-.7 2.3-4.96c.23-.5.72-.83 1.27-.83z';

  function starSvg(state) {
    if (state === 'full') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + STAR_PATH + '"/></svg>';
    }
    if (state === 'dim') {
      return '<svg viewBox="0 0 24 24" class="dim" aria-hidden="true"><path d="' + STAR_PATH + '"/></svg>';
    }
    var gid = 'ilshg' + Math.random().toString(36).slice(2, 8);
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<defs><linearGradient id="' + gid + '"><stop offset="50%" stop-color="var(--ils-star)"/><stop offset="50%" stop-color="var(--ils-star-dim)"/></linearGradient></defs>' +
      '<path d="' + STAR_PATH + '" fill="url(#' + gid + ')"/></svg>';
  }

  function renderStars(el) {
    if (el.dataset.ilsStarsBuilt === '1') return;
    var rate = parseFloat(el.getAttribute('data-rate')) || 0;
    var html = '';
    for (var i = 1; i <= 5; i++) {
      if (rate >= i) html += starSvg('full');
      else if (rate >= i - 0.5) html += starSvg('half');
      else html += starSvg('dim');
    }
    el.innerHTML = html;
    el.dataset.ilsStarsBuilt = '1';
  }

  function renderAllStars(root) {
    var scope = root || document;
    scope.querySelectorAll('.ils-pcl__stars').forEach(renderStars);
  }

  /* All cards advance synchronously every 2s — matches preview script.
     TASK-2930: a card the user just swiped by hand is skipped here while its
     4s "resume" timer is armed (data-ils-paused="1"). When the timer clears
     the flag, the card silently rejoins the rotation on the next tick, moving
     +1 from whatever image the user left it on — i.e. resumes from the current
     photo, in the same forward order the autoplay always used. */
  var RESUME_MS = 4000; // idle time after a manual swipe before autoplay resumes

  /* Move a single card's carousel by `dir` (+1 next / -1 prev) and sync pips. */
  function stepPclCard(slides, dir) {
    var imgs = slides.querySelectorAll('.ils-pcl__slide');
    if (imgs.length < 2) return;
    var cur = 0;
    imgs.forEach(function (s, i) { if (s.classList.contains('is-on')) cur = i; });
    var nxt = (cur + dir + imgs.length) % imgs.length;
    if (nxt === cur) return;
    imgs[cur].classList.remove('is-on');
    imgs[nxt].classList.add('is-on');
    var card = slides.closest('.ils-pcl');
    if (card) {
      var pips = card.querySelectorAll('.ils-pcl__pip');
      if (pips.length) {
        pips[cur % pips.length].classList.remove('is-on');
        pips[nxt % pips.length].classList.add('is-on');
      }
    }
  }

  /* Pause this one card's autoplay and (re)arm the 4s resume timer. */
  function pausePclCard(slides) {
    slides.dataset.ilsPaused = '1';
    if (slides._ilsResumeTimer) clearTimeout(slides._ilsResumeTimer);
    slides._ilsResumeTimer = setTimeout(function () {
      slides._ilsResumeTimer = null;
      delete slides.dataset.ilsPaused;
    }, RESUME_MS);
  }

  var autoplayTimer = null;
  function startAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
    autoplayTimer = setInterval(function () {
      document.querySelectorAll('[data-ils-pcl-slides]').forEach(function (slides) {
        if (slides.dataset.ilsPaused === '1') return; // user is/just was swiping
        // TASK-3129 — the catalog/collection/search product grid must NOT
        // auto-advance card photos: cards there stay on their first image and
        // only change on a manual swipe (wirePclSwipe). Home / related / 404
        // rails are NOT inside #ProductGridContainer, so they keep the timer
        // autoplay wired by TASK-3077.
        if (slides.closest('#ProductGridContainer')) return;
        stepPclCard(slides, 1);
      });
    }, 2000);
  }

  /* TASK-2930 — manual touch-swipe on the card photo.
     Left swipe → next photo, right swipe → previous. Any manual swipe stops
     this card's autoplay immediately (pausePclCard) and re-arms the 4s resume.
     We only hijack the gesture once it is clearly horizontal, so vertical page
     scrolling on the grid and taps that open the product are untouched. */
  function wirePclSwipe(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-ils-pcl-slides]').forEach(function (slides) {
      if (slides.dataset.ilsSwipeBound === '1') return;
      // TASK-3077 — the home-page rails (.shopify-section-ils-rail, Bestsellers +
      // New arrivals) must NOT respond to a manual photo swipe: only the timer
      // autoplay flips the photo there. The catalog/collection grid has no such
      // wrapper, so its cards keep the TASK-2930 hand-swipe untouched. Marking
      // the slide bound (below is skipped) prevents both this call and the grid
      // MutationObserver re-init from ever attaching the touch handlers here.
      if (slides.closest('.shopify-section-ils-rail')) { slides.dataset.ilsSwipeBound = '1'; return; }
      if (slides.querySelectorAll('.ils-pcl__slide').length < 2) return;
      slides.dataset.ilsSwipeBound = '1';

      var link = slides.closest('a');
      var startX = 0, startY = 0;
      var axis = null;      // null (undecided) | 'x' | 'y'
      var active = false;
      var didSwipe = false; // a real swipe happened this gesture → suppress the click

      function onStart(e) {
        if (!e.touches || e.touches.length !== 1) return;
        active = true; axis = null; didSwipe = false;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }
      function onMove(e) {
        if (!active || !e.touches || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (axis === null) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        if (axis !== 'x') return;         // vertical intent → leave page scroll alone
        if (e.cancelable) e.preventDefault(); // own the horizontal gesture
        if (!didSwipe && Math.abs(dx) > 30) {
          didSwipe = true;
          stepPclCard(slides, dx < 0 ? 1 : -1);
          pausePclCard(slides);
        }
      }
      function onEnd() {
        active = false;
        if (didSwipe) {
          // keep the flag briefly so the trailing click (navigation) is suppressed
          setTimeout(function () { didSwipe = false; }, 400);
        }
      }

      slides.addEventListener('touchstart', onStart, { passive: true });
      slides.addEventListener('touchmove', onMove, { passive: false });
      slides.addEventListener('touchend', onEnd);
      slides.addEventListener('touchcancel', onEnd);

      if (link) {
        link.addEventListener('click', function (e) {
          if (didSwipe) { e.preventDefault(); e.stopPropagation(); didSwipe = false; }
        }, true);
      }
    });
  }

  /* Sort: custom popup driven from #ProductGridContainer scope.
     Native <select id="SortBy"> is the source of truth for facets.js — we
     keep it in the DOM (visually-hidden) and only mirror selection from
     the popup tiles. On tile click, set <select> value + dispatch native
     'change' so the existing facet-filters-form submit path runs (Dawn's
     facets.js intercepts and re-renders the grid). */
  function wireSort(root) {
    var scope = root || document;
    var sel = scope.querySelector('#SortBy');
    var trigger = scope.querySelector('[data-ils-sort-trigger]');
    var popup = scope.querySelector('[data-ils-sort-popup]');
    if (!sel || !trigger || !popup) return;

    var label = scope.querySelector('[data-ils-sort-label]');
    function syncLabel() {
      if (!label) return;
      var opt = sel.options[sel.selectedIndex];
      label.textContent = opt ? opt.textContent : '';
    }
    syncLabel();

    /* Idempotent wiring on the form/scope. */
    if (trigger.dataset.ilsWired === '1') return;
    trigger.dataset.ilsWired = '1';

    function tiles() { return popup.querySelectorAll('[data-ils-sort-value]'); }
    function markSelected(value) {
      tiles().forEach(function (t) {
        var on = t.getAttribute('data-ils-sort-value') === value;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
    function openPopup() {
      markSelected(sel.value);
      popup.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
    }
    function closePopup() {
      popup.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') closePopup();
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (popup.hidden) openPopup(); else closePopup();
    });
    popup.querySelectorAll('[data-ils-sort-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closePopup();
      });
    });
    /* TASK-1801 — robust tap-outside-sheet close. The overlay is a sibling
       of the sheet inside the popup container; this catches any tap on the
       dimmed area (including the container background itself, where the
       65% dim now lives), while taps inside the white sheet bubble up but
       are filtered out by the !sheet.contains check. Tile clicks call
       closePopup() themselves after applying sort, so they're unaffected. */
    popup.addEventListener('click', function (e) {
      var sheet = popup.querySelector('.ils-sort-popup__sheet');
      if (sheet && !sheet.contains(e.target)) {
        closePopup();
      }
    });
    tiles().forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        e.preventDefault();
        var value = tile.getAttribute('data-ils-sort-value') || '';
        if (sel.value !== value) {
          sel.value = value;
          syncLabel();
          /* Dawn's facet-filters-form listens for 'input' events on the form
             (debounced 800ms). Dispatch both 'input' and 'change' on the
             select so the form picks up the new sort and re-renders. */
          sel.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
          sel.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
        }
        markSelected(value);
        closePopup();
      });
    });
  }

  /* =============================================================
     QUICK-ADD POPUP — TASK-1768.
     Mirrors the .ils-sort-popup pattern: centered white sheet,
     overlay close, Esc close, fixed z-index. Scoped to clicks
     inside #ProductGridContainer — no global click handlers.
     The cart-add fetch goes through custom-add-toast.js's existing
     /cart/add interceptor (toast + fly thumbnail). After success
     we publish PUB_SUB_EVENTS.cartUpdate (with fresh cartData from
     /cart.js) so custom-cart-icon.js plays the count-bump animation.
     ============================================================= */
  var qaddPopup = null;
  var qaddState = null;

  function pickAddToCartLabel() {
    var dict = {
      en: 'Add to cart',
      ru: 'Добавить',
      de: 'In den Warenkorb',
      lv: 'Pievienot grozam',
      et: 'Lisa korvi',
      lt: 'Į krepšelį'
    };
    var raw = '';
    try { if (typeof window.ILS_LANG === 'string' && window.ILS_LANG) raw = window.ILS_LANG; } catch (e) {}
    if (!raw) {
      try { raw = (window.Shopify && Shopify.locale) || ''; } catch (e) {}
    }
    if (!raw) raw = (document.documentElement && document.documentElement.lang) || '';
    raw = String(raw || '').toLowerCase().slice(0, 2);
    return dict[raw] || dict.en;
  }

  function findWeightOptionIndex(optionNames) {
    if (!optionNames || !optionNames.length) return -1;
    var isW = window.ILS && typeof window.ILS.isWeightOption === 'function'
      ? window.ILS.isWeightOption
      : function () { return false; };
    for (var i = 0; i < optionNames.length; i++) {
      if (isW(optionNames[i])) return i;
    }
    return -1;
  }

  function variantWeightLabel(v, weightIdx) {
    if (weightIdx >= 0) {
      var raw = v['option' + (weightIdx + 1)];
      if (raw != null && raw !== '') {
        if (window.ILS && typeof window.ILS.formatWeight === 'function') {
          return window.ILS.formatWeight(raw);
        }
        return String(raw);
      }
    }
    return v.title || '';
  }

  function buildQaddPopup() {
    var root = document.createElement('div');
    root.className = 'ils-qadd-popup';
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.innerHTML =
      '<div class="ils-qadd-popup__overlay" data-ils-qadd-close></div>' +
      '<div class="ils-qadd-popup__sheet" role="document">' +
        '<img class="ils-qadd-popup__fly-img" data-ils-qadd-img alt="" aria-hidden="true">' +
        '<div class="ils-qadd-popup__head">' +
          '<h2 class="ils-qadd-popup__title" data-ils-qadd-title></h2>' +
          '<button type="button" class="ils-qadd-popup__close" aria-label="Close" data-ils-qadd-close>' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="ils-qadd-popup__tiles" data-ils-qadd-tiles role="radiogroup"></div>' +
        '<div class="ils-qadd-popup__error" data-ils-qadd-error hidden></div>' +
        /* class product-form__submit so custom-add-toast.js remembers
           this button on click for its fly-thumbnail origin. */
        '<button type="button" class="ils-qadd-popup__submit product-form__submit" data-ils-qadd-submit>' +
          '<span data-ils-qadd-submit-label></span>' +
        '</button>' +
      '</div>';
    document.body.appendChild(root);
    root.querySelectorAll('[data-ils-qadd-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeQaddPopup();
      });
    });
    root.querySelector('[data-ils-qadd-submit]').addEventListener('click', function (e) {
      e.preventDefault();
      submitQadd();
    });
    root.addEventListener('click', function (e) {
      var sheet = root.querySelector('.ils-qadd-popup__sheet');
      if (sheet && !sheet.contains(e.target)) {
        closeQaddPopup();
      }
    });
    return root;
  }

  function ensureQaddPopup() {
    if (!qaddPopup || !document.body.contains(qaddPopup)) {
      qaddPopup = buildQaddPopup();
    }
    return qaddPopup;
  }

  function onQaddKey(e) {
    if (e.key === 'Escape') closeQaddPopup();
  }

  function openQaddFromBtn(btn) {
    var variants, optionNames;
    try { variants = JSON.parse(btn.getAttribute('data-ils-variants') || '[]'); } catch (e) { variants = []; }
    try { optionNames = JSON.parse(btn.getAttribute('data-ils-option-names') || '[]'); } catch (e) { optionNames = []; }
    if (!Array.isArray(variants) || variants.length === 0) return;

    var weightIdx = findWeightOptionIndex(optionNames);
    var selectedIdx = -1;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].available) { selectedIdx = i; break; }
    }
    if (selectedIdx < 0) selectedIdx = 0;

    qaddState = {
      variants: variants,
      optionNames: optionNames,
      weightIdx: weightIdx,
      selectedIdx: selectedIdx,
      productTitle: btn.getAttribute('data-ils-product-title') || '',
      productUrl: btn.getAttribute('data-ils-product-url') || '',
      sourceBtn: btn
    };

    ensureQaddPopup();
    renderQadd();
    qaddPopup.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onQaddKey);
  }

  /* Sync across 3 places — see window.ILS.weightRows in custom-weight.js
     and the Liquid copy in sections/custom-main-product.liquid.
     TASK-1864: dropped 5-in-a-row; max row width is 4. */
  function pickWeightRows(n) {
    if (window.ILS && typeof window.ILS.weightRows === 'function') {
      return window.ILS.weightRows(n);
    }
    n = Math.max(0, parseInt(n, 10) || 0);
    if (n === 0) return [];
    if (n <= 4) return [n];
    switch (n) {
      case 5: return [3, 2];
      case 6: return [3, 3];
      case 7: return [4, 3];
      case 8: return [4, 4];
      case 9: return [3, 3, 3];
      case 10: return [4, 3, 3];
      default: {
        var rows = [], rem = n;
        while (rem > 4) { rows.push(4); rem -= 4; }
        if (rem > 0) rows.push(rem);
        return rows;
      }
    }
  }

  function renderQadd() {
    if (!qaddState || !qaddPopup) return;
    qaddPopup.querySelector('[data-ils-qadd-title]').textContent = qaddState.productTitle;
    var tilesWrap = qaddPopup.querySelector('[data-ils-qadd-tiles]');
    tilesWrap.innerHTML = '';

    var rows = pickWeightRows(qaddState.variants.length);
    var cursor = 0;
    rows.forEach(function (cols) {
      var row = document.createElement('div');
      row.className = 'ils-qadd-popup__row c' + cols;
      for (var j = 0; j < cols; j++) {
        var i = cursor++;
        var v = qaddState.variants[i];
        if (!v) break;
        var tile = document.createElement('button');
        tile.type = 'button';
        var isSel = (i === qaddState.selectedIdx);
        var avail = !!v.available;
        tile.className = 'ils-qadd-popup__tile' + (isSel ? ' is-selected' : '') + (avail ? '' : ' is-oos');
        tile.setAttribute('role', 'radio');
        tile.setAttribute('aria-checked', isSel ? 'true' : 'false');
        if (!avail) tile.setAttribute('aria-disabled', 'true');
        tile.dataset.idx = String(i);
        var label = variantWeightLabel(v, qaddState.weightIdx);
        var price = v.price_formatted || '';
        var weightSpan = document.createElement('span');
        weightSpan.className = 'ils-qadd-popup__tile-weight';
        weightSpan.textContent = label;
        var priceSpan = document.createElement('span');
        priceSpan.className = 'ils-qadd-popup__tile-price';
        priceSpan.textContent = price;
        tile.appendChild(weightSpan);
        tile.appendChild(priceSpan);
        if (avail) {
          (function (idx) {
            tile.addEventListener('click', function (e) {
              e.stopPropagation();
              qaddState.selectedIdx = idx;
              renderQadd();
            });
          })(i);
        }
        row.appendChild(tile);
      }
      tilesWrap.appendChild(row);
    });
    // Submit button label + disabled state
    var submitBtn = qaddPopup.querySelector('[data-ils-qadd-submit]');
    var submitLbl = submitBtn.querySelector('[data-ils-qadd-submit-label]');
    submitLbl.textContent = pickAddToCartLabel();
    var sel = qaddState.variants[qaddState.selectedIdx];
    submitBtn.disabled = !(sel && sel.available);
    // Hidden image — feeds custom-add-toast.js findProductImageForBtn so the
    // fly thumbnail uses the selected variant's photo (or product fallback).
    var hiddenImg = qaddPopup.querySelector('[data-ils-qadd-img]');
    if (hiddenImg) {
      var src = (sel && sel.image) ? sel.image : '';
      if (src && hiddenImg.getAttribute('src') !== src) hiddenImg.setAttribute('src', src);
    }
    // Reset error
    var errEl = qaddPopup.querySelector('[data-ils-qadd-error]');
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
  }

  function closeQaddPopup() {
    if (!qaddPopup || qaddPopup.hidden) return;
    qaddPopup.hidden = true;
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onQaddKey);
  }

  function showQaddError(msg) {
    if (!qaddPopup) return;
    var errEl = qaddPopup.querySelector('[data-ils-qadd-error]');
    if (!errEl) return;
    errEl.textContent = String(msg || 'Error');
    errEl.hidden = false;
  }

  function submitQadd() {
    if (!qaddState) return;
    var v = qaddState.variants[qaddState.selectedIdx];
    if (!v || !v.available || !v.id) return;
    var submitBtn = qaddPopup.querySelector('[data-ils-qadd-submit]');
    if (!submitBtn || submitBtn.disabled) return;
    submitBtn.disabled = true;

    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    /* Use the .js endpoint explicitly — Shopify accepts both
       /cart/add and /cart/add.js for JSON POSTs but the .js form
       guarantees a JSON response. custom-add-toast.js matches
       both via its /cart/add(.js)? regex, so toast + fly fire. */
    var addJs = /\.js(\?|$)/.test(addUrl) ? addUrl : (addUrl.replace(/\/?$/, '') + '.js');
    var body = {
      items: [{ id: v.id, quantity: 1 }],
      sections_url: window.location.pathname
    };
    fetch(addJs, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, status: r.status, data: data };
        }).catch(function () {
          return { ok: r.ok, status: r.status, data: null };
        });
      })
      .then(function (out) {
        if (!out.ok || (out.data && out.data.status && out.data.status !== 200)) {
          var msg = (out.data && (out.data.description || out.data.message)) || 'Error';
          showQaddError(msg);
          submitBtn.disabled = false;
          return;
        }
        // NOTE: do NOT call drawer.renderContents(out.data) here.
        // It morphs #cart-icon-bubble, which fires the MutationObserver in
        // custom-cart-icon.js → silent syncFromCount(lastKnownCount) BEFORE
        // cartUpdate publishes the new count. The observer then sees prev===new
        // and skips the drop→kick→bump→splash animation. Let the icon be
        // owned exclusively by custom-cart-icon.js via the cartUpdate
        // subscription below. The cart drawer will lazily re-render its
        // contents the next time it opens.

        // Fetch fresh cart for item_count + total_price, then publish.
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            try {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'ils-card-qadd',
                  cartData: cart
                });
              }
            } catch (e) {}
            try { document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: cart } })); } catch (e) {}
          })
          .catch(function () {
            /* Even on /cart.js failure, custom-cart-icon.js subscriber
               re-fetches /cart.js on a no-data publish, so attempt it. */
            try {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ils-card-qadd' });
              }
            } catch (e) {}
            try { document.dispatchEvent(new CustomEvent('cart:update')); } catch (e) {}
          })
          .finally(function () {
            closeQaddPopup();
          });
      })
      .catch(function (err) {
        showQaddError((err && err.message) ? err.message : 'Network error');
        submitBtn.disabled = false;
      });
  }

  function wireQaddTriggers() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    if (container.dataset.ilsQaddWired === '1') return;
    container.dataset.ilsQaddWired = '1';
    container.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-ils-qadd-trigger]');
      if (!btn) return;
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      e.preventDefault();
      openQaddFromBtn(btn);
    });
  }

  function boot() {
    renderAllStars();
    startAutoplay();
    wirePclSwipe();
    wireSort();
    wireQaddTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  /* Facets re-render the grid container without firing DOMContentLoaded.
     Watch #ProductGridContainer for childList changes and re-init. */
  function observeGrid() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    var mo = new MutationObserver(function () {
      renderAllStars(container);
      wirePclSwipe(container);
      wireSort();
      wireQaddTriggers();
    });
    mo.observe(container, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeGrid, { once: true });
  } else {
    observeGrid();
  }
})();
